import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LangRouterLink } from '@pyg-directives/lang-router-link.directive';
import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  iconoirAntenna,
  iconoirCpu,
  iconoirDashboardDots,
  iconoirGraphUp,
} from '@ng-icons/iconoir';

@Component({
  selector: 'app-platform-teaser',
  templateUrl: './platform-teaser.component.html',
  styleUrls: ['./platform-teaser.component.scss'],
  imports: [TranslatePipe, LangRouterLink, NgIcon],
  providers: [provideIcons({ iconoirAntenna, iconoirCpu, iconoirDashboardDots, iconoirGraphUp })],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformTeaserComponent {
  readonly pipelineSteps = [
    { icon: 'iconoirAntenna', labelKey: 'main_page.platform_teaser.step_collect' },
    { icon: 'iconoirCpu', labelKey: 'main_page.platform_teaser.step_process' },
    { icon: 'iconoirDashboardDots', labelKey: 'main_page.platform_teaser.step_deliver' },
    { icon: 'iconoirGraphUp', labelKey: 'main_page.platform_teaser.step_scale' },
  ];
}
